import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from "react";
import * as Mui from "@mui/material";
import { useFetch } from "services/hooks/useFetch";
import {
  themes,
  scrollTop,
  tableRowSize,
  defaultAllSelection,
  iconStyle,
} from "services/constants";
import { useSelector, useDispatch } from "react-redux";
import { showToast } from "services/utils/Status";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { Loader } from "components/Loader";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { AssignShiftGradeHeader } from "pages/Administration/AdministrationHeaders";
import { IndividualUserShiftGradeDetails } from "pages/Administration/AdministrationHeaders";
import { ViewAssignmentPanel } from "../Components/ViewAssignmentPanel";
import { BulkAssignmentPanel } from "../Components/BulkAssignmentPanel";
import comLogo from "../../../../../assets/img/brand/company_logo.png";
import { customGetAPI } from "services/utils/CustomAPI";
import { CompanyProgress } from "components/CustomComponents/CustomSlider";
import { EmployeeView } from "../EmployeeView";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { userShiftGroupHeader } from "pages/Administration/AdministrationHeaders";
import { Typography, Box, Paper, IconButton, Drawer } from "@mui/material";
import { setFilterApi } from "services/Redux/userManagament";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import sessionHandling from "services/utils/notificationUtils";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { customAPI } from "services/utils/CustomAPI";
import {
  SwapHorizontalCircle,
  RemoveRedEye,
  KeyboardArrowDown,
  KeyboardArrowRight,
} from "@mui/icons-material";
import { ViewShiftGroup } from "./ViewShiftGroup";
import { useForm } from "react-hook-form";
import { CustomTextBox } from "components/CustomComponents";
import { CustomButton } from "components/CustomComponents";
import moment from "moment";
import { useSaveView } from "components/CustomComponents/useSaveView";

export const AssignShiftGroup = ({ setSelectedShiftItem, subModuleId }) => {
  const requestCompanyId = useSelector((state) => state.tokenReducer.topbarCompanyId);
  const { domain, userScreenAccess, token, topbarCompanyName, userDetails } =
    useSelector((state) => state.tokenReducer);
  const [selectedComponet, setSelectedComponent] = useState("Employee View");
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [shiftGroupDetails, setShiftGroupDetails] = useState([]);
  const [userData, setUserData] = useState({});
  const [updateData, setUpdateData] = useState(true);
  const [vwSftGrp, setVwSftGrp] = useState(false);
  const [selectedItem, setSelectedItem] = useState("");
  const [expendRowId, setExpendRowId] = useState(0);
  const [individualLoader, setIndividualLoader] = useState(false);
  const [expandDetails, setExapandDetils] = useState([]);
  const [expandItem, setExpandItem] = useState([]);
  const [triggerApi, setTriggerApi] = useState(false);
  const containerRef = useRef(null);
  const [showUserView, setShowUserView] = useState(true);
  const [userShiftGroupDetails, setUserShiftGroupDetails] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [trigger, setTrigger] = useState(true);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [recallGetApi, setRecallGetApi] = useState(false);
  const {
    register,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    defaultValues: {
      shift_group_name: "",
    },
  });
  // This is the Shift Group screen's own group-view gate — it correctly
  // checks "Group Shift Group". A second variable, group_check_access,
  // used to duplicate this but checked "Group Shift Grade" instead (a
  // copy-paste from the sibling Assignment/ShiftGrade/index.js screen,
  // where that string is the correct one). group_check_access was wired
  // to the actual tab-level gate in 4 places while this correctly-named
  // check_access sat almost unused, so a user granted Shift Group access
  // but not Shift Grade access was wrongly blocked, and vice versa.
  // Removed group_check_access entirely and pointed every place it was
  // used at this one instead, rather than just fixing its string, since a
  // second differently-named variable checking the same thing invites the
  // same mistake again later.
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Shift",
    "Group Shift Group",
  );

  let employee_check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Shift",
    "Employee Shift Group",
  );

  const {
    result: shiftData,
    setLoad: reCallApi,
    loading,
  } = useFetch(
    `${domain}administration/shiftroster/userassignment/shiftgroup/employee/count/?company_id=${requestCompanyId}`,
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    if (shiftData?.length !== 0 && updateData) {
      setShiftGroupDetails(shiftData);
    }
  }, [shiftData, updateData]);

  const [isCreatePanelOpen, setIsCreatePanelOpen] = useState(false);
  const [isViewPanelOpen, setIsViewPanelOpen] = useState(false);

  const handleMoveShiftGroup = () => {
    setIsCreatePanelOpen(true);
  };

  const handleViewShiftGroup = () => {
    setIsViewPanelOpen(true);
  };

  const handleCreateClosePanel = () => {
    setIsCreatePanelOpen(false);
  };

  const handleViewClosePanel = () => {
    setIsViewPanelOpen(false);
    setVwSftGrp(false);
  };

  useEffect(() => {
    const fetchIndividualUserDetails = async () => {
      setIndividualLoader(true);
      const res = await customGetAPI(
        `${domain}administration/shiftroster/userassignment/shiftgroup/shift-group-details/?department_id=${defaultAllSelection}&shift_group_id=${expandItem?.id}&user_id=${defaultAllSelection}&company_id=${requestCompanyId}`,
      );
      if (res.ok) {
        setExapandDetils(res?.responseDetails?.data);
        setTriggerApi(false);
        setIndividualLoader(false);
      } else {
        setTriggerApi(false);
        setIndividualLoader(false);
      }
    };
    if (triggerApi) {
      fetchIndividualUserDetails();
    }
  }, [
    domain,
    expandItem?.id,
    expandItem.leave_group_id,
    expandItem.user_id,
    triggerApi, requestCompanyId
  ]);

  const handleFilteredDataChange = useCallback(
    (filteredData) => {
      showUserView
        ? setUserShiftGroupDetails(filteredData)
        : setShiftGroupDetails(filteredData);
      if (page * rowsPerPage >= filteredData.length) setPage(0);
    },
    [page, rowsPerPage, showUserView],
  );

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    reset();
  };

  const onSubmit = async (data) => {
    setValue("button_loader", true);
    const response = await customAPI(
      `${domain}administration/shiftroster/shiftgroups/shift-groups/`,
      "POST",
      {
        primary_shift_grade: 1,
        name: watch("shift_group_name").trim(),
      },
    );
    if (response.ok) {
      showToast("success", "Shift group created.");
      setShowConfirmationDialog(false);
      reset();
      reCallApi(true);
    } else {
      showToast("error", response?.message);
    }
  };

  const updateSftGrpName = (event) => {
    setValue("shift_group_name", event.target.value);
  };

  useEffect(() => {
    if (recallGetApi) {
      reCallApi(true);
      setRecallGetApi(false);
    }
  }, [reCallApi, recallGetApi]);

  const reportMetadata = useMemo(
    () => ({
      "Company Name": topbarCompanyName || "N/A",
      "Report Generated On": moment().format("DD/MM/YYYY HH:mm:ss"),
    }),
    [topbarCompanyName],
  );

  const activeShiftGroupHeaders = useMemo(
    () =>
      showUserView
        ? userShiftGroupHeader
        : // The "Action" entry is the expand-arrow column, not a real data
          // column — it has no name to show/rename and must always render,
          // so it's excluded from the configurable saved-view header set.
          AssignShiftGradeHeader.filter((header) => header.key !== "Action"),
    [showUserView],
  );

  const handleSavedViewChange = useCallback(() => {
    setPage(0);
  }, []);

  const handleRestoreScope = useCallback((scopeValue) => {
    const restoredUserView = scopeValue === "employee";
    setShowUserView(restoredUserView);
    setSelectedComponent(restoredUserView ? "Employee View" : "Group View");
  }, []);

  const { visibleHeaders, titleOverride, newButtonComponent } = useSaveView({
    domain,
    userId: userDetails?.id,
    subModuleId,
    storageKey: "shift_group_assignment_saved_views",
    scope: showUserView ? "employee" : "group",
    fullHeaders: activeShiftGroupHeaders,
    screenAccess: showUserView ? employee_check_access : check_access,
    onRestoreScope: handleRestoreScope,
    onViewChange: handleSavedViewChange,
  });

  return updateData && loading ? (
    <Loader />
  ) : (
    <React.Fragment>
      <ConfirmationDialog
        open={showConfirmationDialog}
        onClose={handleCancelClose}
        onConfirm={handleSubmit(onSubmit)}
        title={"New Shift Group Name"}
        confirmText={"Create"}
        cancelText="Cancel"
        showChildren={true}
      >
        <Box sx={{ mb: 2, display: "flex", alignItems: "center" }}>
          <Typography sx={{ fontWeight: 700, minWidth: 220 }}>
            New Shift Group Name
          </Typography>

          <Typography>:</Typography>
          <Box sx={{ width: "61%", ml: 1 }}>
            <CustomTextBox
              selectedValue={watch("shift_group_name")}
              {...register("shift_group_name", {
                required: "Shift group name is required",
                minLength: {
                  value: 3,
                  message: "Minimum 3 characters are required",
                },
                maxLength: {
                  value: 100,
                  message: "Maximun length is 100 characters",
                },
                validate: {
                  atleastOneCharacterWithSpaceReg: (value) => {
                    if (
                      atleastOneCharacterWithSpace.test(value) ||
                      value === ""
                    ) {
                      return true;
                    } else {
                      return "Atleast one alphabet required";
                    }
                  },
                  editLeaveName: async (fieldValue) => {
                    if (fieldValue.trim() === "") {
                      return "Minimum 3 characters are required";
                    } else {
                      try {
                        const response = await fetch(
                          `${domain}unique/shift-group/?name=${fieldValue.trim()}`,
                          {
                            method: "GET",
                            headers: {
                              "content-type": "application/json",
                              Authorization: `token ${token}`,
                            },
                          },
                        );
                        const res = await response.json();
                        if (response.ok) {
                          if (res.exists) {
                            return "Shift group is already exists";
                          } else {
                            return true;
                          }
                        } else if (response.status === 409) {
                          sessionHandling();
                        } else {
                          throw new Error("REQUEST_FAILED");
                        }
                      } catch (error) {
                        console.error("[Index] operation failed:", error);
                        showToast(
                          "error",
                          "Couldn't save the shift assignment. Please try again.",
                        );
                      }
                    }
                  },
                },
              })}
              updateDataFunction={updateSftGrpName}
              placeHolder="Enter shift group name"
              errorMessage={
                errors?.shift_group_name?.message
                  ? errors?.shift_group_name?.message
                  : ""
              }
              textBoxError={errors.shift_group_name ? true : false}
            />
          </Box>
        </Box>
      </ConfirmationDialog>
      <Box>
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
              Shift Group
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Place employees under a common shift rotation schedule
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >
            <IconButton
              sx={iconStyle}
              onClick={() => {
                if (showUserView ? employee_check_access : check_access) {
                  handleMoveShiftGroup();
                } else {
                  showToast(
                    "error",
                    `Access denied: You are not authorized to move shift group`,
                  );
                }
              }}
            >
              <SwapHorizontalCircle sx={{ color: themes.primaryIndicator }} />
            </IconButton>
          </Box>
        </Box>
        <Box>
          <Box sx={{ display: "flex", gap: 2, ml: 5 }}>
            <Box
              sx={{
                padding: "12px 24px",
                backgroundColor:
                  selectedComponet === "Employee View"
                    ? "white"
                    : "transparent",
                color:
                  selectedComponet === "Employee View"
                    ? "primary.main"
                    : "text.secondary",
                fontWeight: 600,
                cursor: "pointer",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                marginBottom: "-1px",
                "&:hover": {
                  backgroundColor:
                    selectedComponet === "Employee View"
                      ? "white"
                      : "transparent",
                },
              }}
              onClick={() => {
                setShowUserView(true);
                setSelectedComponent("Employee View");
                dispatch(setFilterApi(true));
              }}
            >
              Employee View
            </Box>
            <Box
              sx={{
                padding: "12px 24px",
                backgroundColor:
                  selectedComponet === "Group View" ? "white" : "transparent",
                color:
                  selectedComponet === "Group View"
                    ? "primary.main"
                    : "text.secondary",
                fontWeight: 600,
                cursor: "pointer",
                borderTopLeftRadius: "8px",
                borderTopRightRadius: "8px",
                marginBottom: "-1px",
                "&:hover": {
                  backgroundColor:
                    selectedComponet === "Group View" ? "white" : "transparent",
                },
              }}
              onClick={() => {
                setShowUserView(false);
                setSelectedComponent("Group View");
                dispatch(setFilterApi(true));
              }}
            >
              Group View
            </Box>
          </Box>
        </Box>
        <Paper sx={{ width: "100%", height: "77vh" }}>
          <CustomFilter
            title={showUserView ? "Employee Records" : "Shift Group Records"}
            titleOverride={titleOverride}
            filterHeaders={visibleHeaders}
            data={showUserView ? groupData : shiftData}
            filteredData={
              showUserView ? userShiftGroupDetails : shiftGroupDetails
            }
            onFilteredDataChange={handleFilteredDataChange}
            screenAccess={
              showUserView ? employee_check_access : check_access
            }
            downloadFormats={["excel", "pdf", "csv"]}
            includeMetadata={true}
            metadata={reportMetadata}
            newButtonComponent={
              <>
                {newButtonComponent}
                <CustomButton
                  actionFuntion={() => {
                    if (check_access) {
                      setShowConfirmationDialog(true);
                    } else {
                      showToast(
                        "error",
                        `Access denied: You are not authorized to create shift group`,
                      );
                    }
                  }}
                  actionName="New"
                  typeName="button"
                />
              </>
            }
          />

          {showUserView ? (
            <EmployeeView
              viewComponent={"ShiftGroup"}
              setIsViewPanelOpen={setIsViewPanelOpen}
              setUserData={setUserData}
              userShiftGroupDetails={userShiftGroupDetails}
              setUserShiftGroupDetails={setUserShiftGroupDetails}
              trigger={trigger}
              setTrigger={setTrigger}
              setGroupData={setGroupData}
              page={page}
              setPage={setPage}
              headers={visibleHeaders}
            />
          ) : (
            <Mui.Grid sx={{ ml: 2, mr: 2 }}>
              <Mui.TableContainer ref={containerRef} sx={{ maxHeight: 590 }}>
                <Mui.Table className="border">
                  <Mui.TableHead
                    sx={{
                      backgroundColor: themes.primary,
                      position: "sticky",
                      top: -1,
                      zIndex: 10,
                    }}
                  >
                    <Mui.TableRow sx={tableRowSize}>
                      <Mui.TableCell
                        key="action"
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                        }}
                      />
                      {visibleHeaders?.map((value) => (
                        <Mui.TableCell
                          key={value.key}
                          sx={{
                            color: themes.headLine,
                            fontWeight: "bold",
                          }}
                        >
                          {value?.name}
                        </Mui.TableCell>
                      ))}
                    </Mui.TableRow>
                  </Mui.TableHead>
                  <Mui.TableBody>
                    {shiftGroupDetails?.length === 0 ? (
                      <TableEmptyState dataLength={shiftData} />
                    ) : (
                      shiftGroupDetails
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                        ?.map((value) => (
                          <>
                            <Mui.TableRow key={value.id} sx={tableRowSize}>
                              <Mui.TableCell key={`${value.id}-action`}>
                                {expendRowId === value.id ? (
                                  <Mui.IconButton
                                    onClick={() => setExpendRowId(0)}
                                    size="small"
                                    sx={{ ml: 2.5 }}
                                  >
                                    <KeyboardArrowDown sx={{ fontSize: 18 }} />
                                  </Mui.IconButton>
                                ) : (
                                  <Mui.IconButton
                                    onClick={() => {
                                      setExapandDetils([]);
                                      setExpendRowId(value.id);
                                      setExpandItem(value);
                                      setTriggerApi(true);
                                    }}
                                    size="small"
                                    sx={{ ml: 2.5 }}
                                  >
                                    <KeyboardArrowRight sx={{ fontSize: 18 }} />
                                  </Mui.IconButton>
                                )}
                              </Mui.TableCell>
                              {visibleHeaders.map((head) => (
                                <Mui.TableCell
                                  key={`${value.id}-${head.key}`}
                                  onClick={() => {
                                    console.log("Row Pressed");
                                    setSelectedItem(value);
                                    setVwSftGrp(true);
                                  }}
                                >
                                  {value[head.key] ? value[head.key] : "N/A"}
                                </Mui.TableCell>
                              ))}
                            </Mui.TableRow>
                            {expendRowId === value.id && (
                              <Mui.TableRow>
                                <Mui.TableCell colSpan={12}>
                                  <Mui.TableContainer
                                    sx={{
                                      marginTop: 0,
                                      marginLeft: "auto",
                                      marginRight: "auto",
                                      width: "100%px",
                                    }}
                                    className="w-96 border rounded"
                                  >
                                    <Mui.Table>
                                      <Mui.TableHead
                                        sx={{
                                          backgroundColor: themes.primary,
                                        }}
                                      >
                                        <Mui.TableRow
                                          sx={{
                                            "& .MuiTableCell-root": {
                                              height: "6px",
                                              padding: "6px 10px",
                                            },
                                          }}
                                        >
                                          {IndividualUserShiftGradeDetails.map(
                                            (head) => (
                                              <Mui.TableCell
                                                sx={{
                                                  color: themes.headLine,
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {head.name}
                                              </Mui.TableCell>
                                            ),
                                          )}
                                        </Mui.TableRow>
                                      </Mui.TableHead>
                                      <Mui.TableBody>
                                        {individualLoader ? (
                                          <Mui.TableRow sx={tableRowSize}>
                                            <Mui.TableCell
                                              colSpan={10}
                                              style={{
                                                textAlign: "center",
                                              }}
                                            >
                                              <CompanyProgress
                                                comLogo={comLogo}
                                                themes={themes}
                                              />
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ) : expandDetails.length === 0 &&
                                          !individualLoader ? (
                                          <Mui.TableRow
                                            maxWidth="xl"
                                            align="left"
                                            sx={tableRowSize}
                                          >
                                            <Mui.TableCell colSpan={12}>
                                              <Mui.Alert
                                                sx={{ marginTop: 3 }}
                                                severity="info"
                                              >
                                                No data available
                                              </Mui.Alert>
                                            </Mui.TableCell>
                                          </Mui.TableRow>
                                        ) : (
                                          expandDetails?.map((detail) => (
                                            <Mui.TableRow
                                              sx={{
                                                "& .MuiTableCell-root": {
                                                  height: "10px",
                                                  padding: "10px 10px",
                                                },
                                              }}
                                            >
                                              {IndividualUserShiftGradeDetails?.map(
                                                (head) =>
                                                  head?.key === "Action" ? (
                                                    <Mui.TableCell
                                                      key={head.key}
                                                    >
                                                      <RemoveRedEye
                                                        onClick={() => {
                                                          if (check_access) {
                                                            handleViewShiftGroup();
                                                            setUserData(detail);
                                                          } else {
                                                            showToast(
                                                              "error",
                                                              `Access denied: You are not authorized to move shift grade`,
                                                            );
                                                          }
                                                        }}
                                                        sx={{
                                                          cursor: "pointer",
                                                          color:
                                                            themes?.mutedgreen,
                                                        }}
                                                      />
                                                    </Mui.TableCell>
                                                  ) : (
                                                    <Mui.TableCell
                                                      key={head.key}
                                                    >
                                                      {detail[head.key] ||
                                                      detail[head.key] === 0
                                                        ? detail[head.key]
                                                        : "N/A"}
                                                    </Mui.TableCell>
                                                  ),
                                              )}
                                            </Mui.TableRow>
                                          ))
                                        )}
                                      </Mui.TableBody>
                                    </Mui.Table>
                                  </Mui.TableContainer>
                                </Mui.TableCell>
                              </Mui.TableRow>
                            )}
                          </>
                        ))
                    )}
                  </Mui.TableBody>
                </Mui.Table>
              </Mui.TableContainer>
              <Box sx={{ mt: 1 }}>
                {shiftGroupDetails?.length > 25 && (
                  <Mui.TablePagination
                    className="custom-pagination"
                    component="div"
                    rowsPerPageOptions={[25, 50, 75, 100]}
                    count={shiftGroupDetails?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                )}
              </Box>
            </Mui.Grid>
          )}
        </Paper>
      </Box>

      <Drawer
        anchor="right"
        open={isCreatePanelOpen || isViewPanelOpen || vwSftGrp}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") {
            return;
          }
          isCreatePanelOpen ? handleCreateClosePanel() : handleViewClosePanel();
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: "680px",
            maxWidth: "90vw",
            backgroundColor: themes?.themes?.whiteColor,
          },
        }}
      >
        {isCreatePanelOpen ? (
          <BulkAssignmentPanel
            onClose={handleCreateClosePanel}
            reCallApi={reCallApi}
            isShiftGradePanel={false}
            isShiftGroupPanel={true}
          />
        ) : vwSftGrp ? (
          <ViewShiftGroup
            onClose={handleViewClosePanel}
            selectedItem={selectedItem}
            setRecallGetApi={setRecallGetApi}
            setVwSftGrp={setVwSftGrp}
          />
        ) : isViewPanelOpen ? (
          <ViewAssignmentPanel
            onClose={handleViewClosePanel}
            userData={userData}
            reCallApi={reCallApi}
            setUpdateData={setUpdateData}
            screenAccess={
              showUserView ? employee_check_access : check_access
            }
          />
        ) : null}
      </Drawer>
    </React.Fragment>
  );
};
